const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeihin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 981.96,
    height: 194.93,
    viewBox: "0 0 981.96 194.93",
    xmlns: "http://www.w3.org/2000/svg",
    "data-sanitized-data-name": "Layer 1",
    "data-name": "Layer 1",
    id: "b5cca9a5-08d9-479a-86d3-b1bfe8cdad11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-sanitized-data-name": "layer1",
    "data-name": "layer1",
    id: "bfff8c4b-807b-46e8-9387-6ccbd2df1884"
  }, /*#__PURE__*/React.createElement("g", {
    "data-sanitized-data-name": "g54",
    "data-name": "g54",
    id: "f5cba7c2-4369-45ad-8900-a9bd5bf339f7"
  }, /*#__PURE__*/React.createElement("g", {
    "data-sanitized-data-name": "g56",
    "data-name": "g56",
    id: "e8de676c-36cf-4b22-81ba-608148eab751"
  }, /*#__PURE__*/React.createElement("g", {
    "data-sanitized-data-name": "g62",
    "data-name": "g62",
    id: "ead73d20-a1e7-4386-885b-dc181a540c19"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005bac"
    },
    transform: "translate(170.84 -148.04)",
    d: "M435.27,230.57s4.27,4.49-9.62,36.75c-.21.22-3.63,8.12-3.63,8.12H369.24l20.09-44.87H332.06s4.28,4.49-9.61,36.75C322,268.39,288.9,343,288.9,343h50.43l19-42.74h52.77c-9,20.3-19,42.74-19,42.74h50.64l49.79-112.4Z",
    "data-sanitized-data-name": "path64",
    "data-name": "path64",
    id: "ec6e0bf2-d0e1-4241-a3fc-93817d678b2f"
  })), /*#__PURE__*/React.createElement("g", {
    "data-sanitized-data-name": "g66",
    "data-name": "g66",
    id: "e90ca674-1166-40bc-8a1f-488d91522074"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005bac"
    },
    transform: "translate(170.84 -148.04)",
    d: "M332.43,148l-46.15,23.5-9-23.5-33.76,66.24,33.76-17.95,34.19,23.08L299.1,186.29Z",
    "data-sanitized-data-name": "path68",
    "data-name": "path68",
    id: "a6a743d8-bf30-4f80-9b4f-d6bb9329fe2e"
  })), /*#__PURE__*/React.createElement("g", {
    "data-sanitized-data-name": "g70",
    "data-name": "g70",
    id: "a39d6e42-fbcc-4aec-b002-6615ff74932d"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005bac"
    },
    transform: "translate(170.84 -148.04)",
    d: "M716.79,230.57s4.28,4.7-9.83,37.18l-11.53,26.93-35.9-64.11H611.24s4.06,4.7-9.83,37.18L567.86,343h50.43l26.49-59.62L678.33,343h45.52l50.21-112.4Z",
    "data-sanitized-data-name": "path72",
    "data-name": "path72",
    id: "f518136e-7cbf-4b7f-bf48-b432fae327dc"
  })), /*#__PURE__*/React.createElement("g", {
    "data-sanitized-data-name": "g74",
    "data-name": "g74",
    id: "b037629e-5ab6-4257-90d9-a1c5590ff448"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005bac"
    },
    transform: "translate(170.84 -148.04)",
    d: "M276.33,212.56l-34.19,17.95s4.27,4.92-9.83,37.18l-33.55,75.22h54.49l50-112.4Z",
    "data-sanitized-data-name": "path76",
    "data-name": "path76",
    id: "b720f479-0894-4a8c-aa44-499aaf7815e9"
  })), /*#__PURE__*/React.createElement("g", {
    "data-sanitized-data-name": "g78",
    "data-name": "g78",
    id: "bf0e87ca-3c85-47bd-9d85-e366bb96dd98"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005bac"
    },
    transform: "translate(170.84 -148.04)",
    d: "M521.27,230.57s4.06,4.7-9.83,37.18L477.89,343h54.49l50-112.4Z",
    "data-sanitized-data-name": "path80",
    "data-name": "path80",
    id: "f18da6b0-b1a2-45aa-a80a-14e3880f05c1"
  })), /*#__PURE__*/React.createElement("g", {
    "data-sanitized-data-name": "g82",
    "data-name": "g82",
    id: "a34a20ec-f8ef-401b-a4c9-3cb487c9562d"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005bac"
    },
    transform: "translate(170.84 -148.04)",
    d: "M35.79,230.57H-34.3s-.21,4.7-43.16,37.18L-91.35,278l21.15-47.44h-57.48s4.06,4.7-9.83,37.18L-170.84,343h50.64l20.3-45.73L-59.09,343H-3.53L-48.4,293Z",
    "data-sanitized-data-name": "path84",
    "data-name": "path84",
    id: "ee0bea3b-a4c9-495e-8cd8-313b092f3961"
  })), /*#__PURE__*/React.createElement("g", {
    "data-sanitized-data-name": "g86",
    "data-name": "g86",
    id: "e0bf17bd-a282-44f2-a8a4-cb37f85f7e84"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005bac"
    },
    transform: "translate(170.84 -148.04)",
    d: "M322.86,184.41l-5.56,6.83L325.21,212H773.93l37.18-27.56Z",
    "data-sanitized-data-name": "path88",
    "data-name": "path88",
    id: "b072da94-321e-425d-aa9e-8f68fb377767"
  })), /*#__PURE__*/React.createElement("g", {
    "data-sanitized-data-name": "g90",
    "data-name": "g90",
    id: "aeb483e8-6e3b-4b95-9f73-f75b723a5149"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005bac"
    },
    transform: "translate(170.84 -148.04)",
    d: "M-137.13,184.41c4.27,8.54,7.69,17.73,9,27.56H228.05l14.1-27.56Z",
    "data-sanitized-data-name": "path92",
    "data-name": "path92",
    id: "ec8b879a-f6ac-42b3-ade5-82c67a4dc8c4"
  })), /*#__PURE__*/React.createElement("g", {
    "data-sanitized-data-name": "g94",
    "data-name": "g94",
    id: "e7d18e74-4097-42e2-8166-b50752bf1ebb"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005bac"
    },
    transform: "translate(170.84 -148.04)",
    d: "M201.66,255.28l11.11-24.79H61.06s4.27,4.49-9.62,36.75c-.43,1.07-33.55,75.65-33.55,75.65H165.12l11.32-24.79h-97l7.91-18h93.81l11.11-24.79h-94l9-20.3Z",
    "data-sanitized-data-name": "path96",
    "data-name": "path96",
    id: "a2f41f0b-5e30-4ed9-bad0-3b2f7be3613d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeihin);
export default __webpack_public_path__ + "static/media/keihin.4fc37e516c202f442c2358a175012646.svg";
export { ForwardRef as ReactComponent };